module.exports = __webpack_public_path__ + "img/profile.0f8e789e.jpeg";